/**
 * UspModalSlider
 * @description Web component used to create sliders, configurable with data-options attribute.
 * @documentation https://swiperjs.com/swiper-api
 * @example
 */

import { Swiper } from 'swiper';
import { A11y, Navigation, Autoplay } from 'swiper/modules';

if (!customElements.get('usp-grid')) {
  class UspGrid extends HTMLElement {
    constructor() {
      super();
      this.uspCards = this.querySelectorAll('[data-icon-card]');
      this.swiper = this.querySelector('[data-swiper]');

      // Stop when the swiper is not found
      if (!this.swiper) {
        return;
      }

      // Default to improve user experience
      this.swiperOptions = {
        modules: [A11y, Navigation, Autoplay],
        threshold: 10,
        autoHeight: true,
        loop: true,
      };

      // Check if we have extra options on the HTML
      if (this.swiper.dataset.options) {
        const options = JSON.parse(this.swiper.dataset.options);
        if (options) {
          this.swiperOptions = {
            ...this.swiperOptions,
            ...options,
          };
        }
      }

      // Call swiper with selected swiper element and options
      this.swiperInstance = new Swiper(this.swiper, this.swiperOptions);

      //catch click on modal toggle of each card to open modal with right content
      this.uspCards.forEach((card) => {
        var cardModalToggle = card.querySelector('[data-model-toggle');
        if (cardModalToggle) {
          cardModalToggle.addEventListener('click', () => {
            var cardId = JSON.parse(cardModalToggle.getAttribute('id'));
            if (cardId) {
              const slideIndex = this.matchCardIdWithSlide(cardId);
              if (typeof slideIndex == 'number') {
                this.goToSlide(slideIndex);
                this.swiperInstance.update();
                this.swiperInstance.init();
              }
            }
          });
        }
      });
    }

    /*
     * Match card id with slide
     * @param id {int}: card id
     */
    matchCardIdWithSlide(cardId) {
      if (!cardId || !this.swiper) {
        return false;
      }

      // Get slides
      const slides = this.swiper.querySelectorAll('[data-swiper-slide-index]');
      // Match id with slides id's
      const slide = [...slides].find((slide) => {
        // Get card id's attached to slide
        const slideItem = JSON.parse(slide.id);
        // Check if card id match the slide variant id's
        if (slideItem === cardId) {
          return slide;
        }
      });

      if (!slide) {
        return false;
      }

      // return matched slide index
      return getNodeIndex(slide);
    }

    /*
     * go to slide
     * @param slide {node} / {int}: slide node / index
     */
    goToSlide(slide) {
      if ((typeof slide != 'number' && typeof slide != 'object') || !this.swiperInstance) {
        return false;
      }

      // Get index, transform node to slide index or string to int
      const index = typeof slide == 'number' ? parseInt(slide) : getNodeIndex(slide);

      // go to slide
      this.swiperInstance.slideTo(index);
    }
  }

  window.UspGrid = UspGrid;
  customElements.define('usp-grid', UspGrid);
}
